import React from 'react';
import { View } from 'react-native';

import ColorsWrapper from '@styles/colors';

import MachineDetails from '@components/machines/machineDetails';

const PanelView = (props) => {
  const params = props?.route?.params || {};
  return (
    <View style={{ width: '100%', height: '100%' }}>
      <MachineDetails {...{ ...props, ...params, panelViewMode: true }} />
    </View>
  );
};

export default ColorsWrapper(PanelView);
